/* ═══════════════════════════════════════════════════════════════
 * DRAWINGS STORAGE — bewaart de tekeningen (drawTools-lijnen) per
 * symbool in localStorage, zodat ze een page-reload of opnieuw
 * inloggen overleven. Puur browser-lokaal (geen server/account-sync) —
 * dezelfde beperking als de rest van de app z'n localStorage-gebruik.
 * ═══════════════════════════════════════════════════════════════ */

const PREFIX = "coach_drawings_";

function key(symbol) {
  return PREFIX + symbol;
}

export function loadDrawings(symbol) {
  try {
    const raw = localStorage.getItem(key(symbol));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return []; // corrupte data of privé-modus → gewoon leeg beginnen
  }
}

export function saveDrawings(symbol, lines) {
  try {
    localStorage.setItem(key(symbol), JSON.stringify(lines || []));
  } catch {
    /* quota/privé-modus — negeren, tekenen blijft gewoon werken */
  }
}
